
            const data = {"name":"back","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" d=\"M13.76 26.103 3.657 16 13.76 5.897M28.343 16H3.657h24.686z\" _stroke=\"#292929\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#292929"}],"stopColors":[]}}
        
                    module.exports = data
                    